module.exports = __webpack_public_path__ + "static/8-7541a7da389329c064b7ebdfa95882dc.jpg";